import Config from "../config/env";

export let TRUSTED_AUTHKIT_HOST = new URL(Config.WORKOS_LOGIN_URL).host || null;

if (!TRUSTED_AUTHKIT_HOST) {
  console.warn(
    "Couldn't determine TRUSTED_AUTHKIT_HOST. Defaulting to `supportive-avenue-54-staging.authkit.app`. Consider setting this variable for better configurability.",
  );
  // Default to the staging environment
  TRUSTED_AUTHKIT_HOST = "supportive-avenue-54-staging.authkit.app";
}

const HOSTS_WHITELIST: string[] = [
  TRUSTED_AUTHKIT_HOST || "supportive-avenue-54-staging.authkit.app",
  Config.WORK_OS_API_HOST || "api.workos.com",
];

/**
 * Validates a given URL to ensure it matches the trusted host.
 *
 * This function parses the provided URL using the `URL` class and
 * verifies that its host matches the trusted host specified
 * in the environment variable `AUTHKIT_HOST`
 * and that the protocol is HTTPS.
 *
 * @param {string} url - The URL to validate.
 * @returns {boolean} - Returns `true` if the URL's host matches the trusted host, `false` if it does not or if the URL is invalid.
 */
export const isValidRedirectUrl = (url: string) => {
  try {
    const { host, protocol } = new URL(url);

    // Ensure the host of the URL matches the trusted host
    const isHostValid =
      Array.isArray(HOSTS_WHITELIST) && HOSTS_WHITELIST.includes(host);

    // Ensure the protocol of the URL is HTTPS
    const isProtocolValid = protocol === "https:";

    return isHostValid && isProtocolValid;
  } catch (e: unknown) {
    // Check if e is an instance of Error before accessing message property
    const errorMessage = e instanceof Error ? e.message : String(e);
    console.error("Invalid URL format:", url, errorMessage);
    return false;
  }
};
